import React, { useState } from "react";
import { Users, UserCog, ShieldCheck } from "lucide-react";
import { PageHead } from "../components/PageHead";
import StaffUsers from "./StaffUsers";
import CustomerUsers from "./CustomerUsers";
import PermissionsMatrix from "../components/PermissionsMatrix";

const TABS = [
  ["staff", "Staff Users", Users],
  ["customers", "Customer Users", UserCog],
  ["permissions", "Permissions", ShieldCheck],
];

export default function UsersPermissions() {
  const [tab, setTab] = useState("staff");

  return (
    <>
      <PageHead
        crumb="Administration"
        title="Users & Permissions"
        sub="Internal PTE staff, customer portal logins, and the role permission matrix."
      />
      <div className="ftabs">
        {TABS.map(([k, label, Icon]) => (
          <button
            key={k}
            className={`ftab ${tab === k ? "active" : ""}`}
            onClick={() => setTab(k)}
            data-testid={`users-tab-${k}`}
          >
            <Icon size={13} style={{ verticalAlign: "-2px", marginRight: 5 }} />
            {label}
          </button>
        ))}
      </div>

      {tab === "staff" && <StaffUsers embedded />}
      {tab === "customers" && <CustomerUsers embedded />}
      {tab === "permissions" && <PermissionsMatrix />}
    </>
  );
}
